import { DetailRequirement, FieldModel } from '@cibo/core'
import { useFieldColumns } from '@cibo/landmanager'
import { DataGridPro } from '@cibo/ui'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useProgramEngagementContext } from '../../../../context'
import { resourceDetailFeatureByTraitId } from '../../Tasks/BenchmarkStatus/resourceDetailFeatureMap'

type FieldDetailsTableProps = {
  detailRequirements: DetailRequirement[]
  engagement: any
}

export const FieldDetailsTable = ({ detailRequirements, engagement }: FieldDetailsTableProps) => {
  const { t } = useTranslation('@cibo/programs/Display')

  const { fieldNameColumn } = useFieldColumns()

  const { fieldModels } = useProgramEngagementContext()

  const columns = useMemo(() => {
    return [
      fieldNameColumn,
      ...detailRequirements.map(({ programId, ...rest }) => {
        const requirement = {
          ...rest,
          programId: programId === '$programId' ? engagement.data?.programId : programId,
        }

        const Feature = resourceDetailFeatureByTraitId(requirement.traitId)

        const DetailCell = Feature?.Component?.SimpleCellView

        return {
          field: JSON.stringify(requirement),
          headerName: t(requirement.traitId, { ns: 'traits' }),
          flex: 1,
          hideable: false,
          disableColumnMenu: true,
          filterable: false,
          valueGetter: (_: any, row: FieldModel) => {
            const detail = row.findDetail(requirement)
            return detail
          },
          renderCell: ({ value }: GridRenderCellParams<FieldModel>) => {
            if (!value) return null

            if (DetailCell) {
              return <DetailCell detail={value} />
            }

            return <>{JSON.stringify(value)}</>
          },
        }
      }),
    ]
  }, [fieldModels.dataUpdatedAt])

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <DataGridPro
        columns={columns}
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        hideCellFocus
        rows={fieldModels.data?.items || []}
        loading={fieldModels.isPending}
      />
    </div>
  )
}
